var Conjuration = {
    handle: "conjuration",
    
    abilities: {
        void_spike: {
            handle: "void_spike",
            unlockLevel: 1 
        },

        mana_node: {
            handle: "mana_node",
            unlockLevel: 9,
            passive: true 
        },

        summon_dwarf: {
            handle: "summon_dwarf",
            unlockLevel: 17 
        },

        summon_elf: {
            handle: "summon_elf",
            unlockLevel: 25 
        },
        
        summon_faerie: {
            handle: "summon_faerie",
            unlockLevel: 33 
        },
        
        summon_option: {
            handle: "summon_option",
            unlockLevel: 41 
        },

        teleport: {
            handle: "teleport",
            unlockLevel: 49
        }
    }
};
module.exports = Conjuration;